/** ----------------------------------------
    Interface
---------------------------------------- */

import { ProjectStore } from '@interface/store/Project';

/** ----------------------------------------
 State
---------------------------------------- */

export default {
    current: (state: ProjectStore) => state.current
};